"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

var _styles2 = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Loader = function Loader(_ref) {
  var classes = _ref.classes,
      complete = _ref.complete,
      props = _objectWithoutProperties(_ref, ["classes", "complete"]);

  return _react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])(classes.root, complete ? classes.complete : classes.spinner)
  }, props), complete && _react["default"].createElement("svg", {
    className: classes.checkSvg,
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    fill: "none",
    d: "M14.1 27.2l7.1 7.2 16.7-16.8"
  })));
};

Loader.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Bool flag to show checkmark when loading is complete */
  complete: _propTypes["default"].bool,

  /* eslint-disable react/no-unused-prop-types */
  // These props are not used here by the component itself, but by the jss styles

  /** Loader can be customised by giving a color for the background */
  color: _propTypes["default"].string,

  /** Scales the loader icon size in increments of 35px */
  scale: _propTypes["default"].number
  /* eslint-enable */

};
Loader.defaultProps = {
  complete: false,
  color: _styles2.colors.blue,
  scale: 1
};

var _default = (0, _withStyles["default"])(_styles["default"])(Loader);

exports["default"] = _default;